var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid06({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83,8.46l-1.06.12a.76.76,0,0,0-.2-.49.61.61,0,0,0-.43-.15.72.72,0,0,0-.59.31,2.62,2.62,0,0,0-.3,1.3,1.32,1.32,0,0,1,1-.49,1.57,1.57,0,0,1,1.18.53,1.89,1.89,0,0,1,.49,1.35,1.92,1.92,0,0,1-.52,1.41,1.76,1.76,0,0,1-1.32.53,1.78,1.78,0,0,1-1.43-.67A3.5,3.5,0,0,1,6.12,10,3.51,3.51,0,0,1,6.7,7.73,1.86,1.86,0,0,1,8.21,7a1.59,1.59,0,0,1,1.08.37A1.69,1.69,0,0,1,9.83,8.46ZM7.35,10.85a1.26,1.26,0,0,0,.24.83.74.74,0,0,0,.56.29.63.63,0,0,0,.51-.24A1.17,1.17,0,0,0,8.87,11a1.32,1.32,0,0,0-.22-.82.71.71,0,0,0-.55-.26.72.72,0,0,0-.54.25A1.11,1.11,0,0,0,7.35,10.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid06);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_06.b0fffdc4bbc82548ee0aa2c3deceac85.svg";
export { ForwardRef as ReactComponent };